import {Events} from '../../@types/wishlist.js';
import {AbstractApi} from '../service/abstract-api.js';

export class EventApiInstance extends AbstractApi {
  async postEventsSeenUntil(endpoint: string, maxUnseenOccasionDate: string) {
    await this.post(endpoint, 'Events', { eventsSeenUntil: maxUnseenOccasionDate });
  }

  async getEvents(endpoint: string): Promise<Events> {
    return this.get<Events>(endpoint, 'Events');
  }
}

export const eventApi = new EventApiInstance();
